import {
  AddRoleLegalEntitiesDocument,
  AddRoleLegalEntitiesMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useAddRoleLegalEntities = () => {
  const [mutate] = useMutation(AddRoleLegalEntitiesDocument, {
    extractorFn: (data: AddRoleLegalEntitiesMutation) =>
      data.jobCatalogMutations.addLegalEntitiesJobcatalogRole,
  })

  const addRoleSupervisor = (id: string, legalEntitiesIds: string[]) => {
    return mutate({ variables: { id, legalEntitiesIds } })
  }

  return addRoleSupervisor
}

export default useAddRoleLegalEntities
